export default __webpack_public_path__ + "static/media/toilichte.fea2f806.mp3";